<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>邮件管理</span>
        </div>

        <el-form label-position="top" :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="ID">
              <el-input v-model.number="item.id" style="width: 90px;" placeholder="ID" />
            </el-form-item>
            <el-form-item label="开始时间">
              <el-input v-model="item.online_start" style="width: 90px;" placeholder="开始时间" />
            </el-form-item>
            <el-form-item label="结束时间">
              <el-input v-model="item.online_end" style="width: 90px;" placeholder="结束时间" />
            </el-form-item>
            <el-form-item label="等级">
              <el-input v-model="item.level_start" style="width: 90px;" placeholder="开始等级" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model="item.level_end" style="width: 90px;" placeholder="结束等级" />
            </el-form-item>
            <el-form-item label="积分">
              <el-input v-model="item.score_start" style="width: 90px;" placeholder="开始积分" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model="item.score_end" style="width: 90px;" placeholder="结束积分" />
            </el-form-item>
            <el-form-item label="显示天数">
              <el-input v-model="item.days" style="width: 90px;" placeholder="显示天数" />
            </el-form-item>
            <el-form-item label="版本">
              <el-input v-model="item.version" style="width: 90px;" placeholder="版本" />
            </el-form-item>
            <el-form-item label="设备类型">
              <el-select v-model="item.sid" style="width: 80px" placeholder="请选择">
                <el-option
                  v-for="(item, index) in sidType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="语言">
              <el-select v-model="item.langs" multiple placeholder="请选择" @change="(v)=>{return selectChange(v, index)}">
                <el-option
                  v-for="(item, index) in lang"
                  :key="index"
                  :label="item"
                  :value="index"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="text" @click="userVisibleVisible[index].visible = true">发送用户</el-button>
              <el-dialog
                title="发送用户"
                :visible="userVisibleVisible[index].visible"
                width="600px"
                :before-close="(v)=>{return handleUserClose(v, index)}"
              >
                <el-form-item label="用户" style="margin-top: 8px;">
                  <el-input
                    v-model="item.uids"
                    type="textarea"
                    style="width: 500px"
                    :rows="5"
                    placeholder="请输入内容"
                  />
                </el-form-item>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="userVisibleVisible[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="userVisibleVisible[index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button type="text" @click="titleDialogVisible[index].visible = true">标题</el-button>
              <el-dialog
                title="标题"
                :visible="titleDialogVisible[index].visible"
                width="600px"
                :before-close="(v)=>{return handleTitleClose(v, index)}"
              >
                <el-row v-for="(l, li) in item.langs" :key="li">
                  <el-form-item :label="lang[l]" style="margin-top: 8px;">
                    <el-input v-model="item.title[li]" style="width: 480px;" :placeholder="lang[l]" />
                  </el-form-item>
                </el-row>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="titleDialogVisible[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="titleDialogVisible[index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button type="text" @click="ContentDialogVisible[index].visible = true">内容</el-button>
              <el-dialog
                title="内容"
                :visible="ContentDialogVisible[index].visible"
                width="630px"
                :before-close="(v)=>{return handleContentClose(v, index)}"
              >
                <el-row v-for="(l, li) in item.langs" :key="li">
                  <el-form-item :label="lang[l]" style="margin-top: 8px;">
                    <el-input
                      v-model="item.body[li]"
                      type="textarea"
                      style="width: 500px"
                      :autosize="{ minRows: 3, maxRows: 6}"
                      placeholder="请输入内容"
                    />
                  </el-form-item>
                </el-row>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="ContentDialogVisible[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="ContentDialogVisible[index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button type="text" @click="rewardVisibleVisible[index].visible = true">奖励</el-button>
              <el-dialog
                title="奖励"
                :visible="rewardVisibleVisible[index].visible"
                width="730px"
                :before-close="(v)=>{return handleRewardClose(v, index)}"
              >
                <el-form :inline="true">
                  <el-row v-for="(pp,pi) in item.rewards" :key="pi">
                    <el-form-item label="道具" style="margin-top: 10px;">
                      <el-select v-model.number="pp.propsId" style="width: 130px;" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in rewardType"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="奖品数量" style="margin-top: 10px;">
                      <el-input v-model.number="pp.num" style="width: 130px;" placeholder="奖品数量" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;" label="金币取值">
                      <el-select v-model.number="pp.rtype" :disabled="pp.propsId !== 14" placeholder="请选择" style="width: 120px">
                        <el-option
                          v-for="item in selectType"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      <el-button v-permisaction="['config:signIn:add']" type="danger" @click="removeReward(index, pi)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item style="margin-top: 10px">
                    <el-button type="primary" @click="addReward(index)">+</el-button>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="rewardVisibleVisible[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="rewardVisibleVisible[index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:signInSkin:del']" type="danger" @click="del(index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:signInSkin:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:signInSkin:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { updateActiveNameCfg } from '@/api/config/active-name-cfg'
import { getRewardType } from '@/api/config/slot'
export default {
  name: 'Email',
  data() {
    return {
      rewardType: [],
      titleDialogVisible: [{ visible: false }],
      ContentDialogVisible: [{ visible: false }],
      rewardVisibleVisible: [{ visible: false }],
      userVisibleVisible: [{ visible: false }],
      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'TW': '繁 体',
        'FR': '法 语',
        'DE': '德 语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'TH': '泰 语',
        'VN': '越 南',
        'NO': '挪 威',
        'ID': '印 尼'
      },
      sidType: [
        { label: '安卓', value: 1 },
        { label: 'IOS', value: 2 }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      formData: [
        {
          'id': 1,
          'online_start': '',
          'online_end': '',
          'start_time': '',
          'end_time': '',
          'level_start': 0,
          'level_end': 0,
          'score_start': 0,
          'score_end': 0,
          'sid': 1,
          'langs': [],
          'title': {},
          'body': {},
          'rewards': [{
            propsId: 0,
            skin: 0,
            num: 0,
            rtype: 2
          }],
          'days': 0,
          'uids': [],
          'version': ''
        }
      ]
    }
  },
  created() {
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.name === '') {
          this.msgError('名称不能为空')
          return
        }

        if (_data.type === '') {
          this.msgError('类型不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateActiveNameCfg({ name: this.name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {

    },
    add() {
      this.formData.push({
        'id': 0,
        'online_start': '',
        'online_end': '',
        'start_time': '',
        'end_time': '',
        'level_start': 0,
        'level_end': 0,
        'score_start': 0,
        'score_end': 0,
        'sid': 0,
        'langs': [],
        'title': {},
        'body': {},
        'rewards': [{
          propsId: 0,
          skin: 0,
          num: 0,
          rtype: 2
        }],
        'days': 0,
        'uids': [],
        'version': ''
      })
      this.titleDialogVisible.push({ visible: false })
      this.ContentDialogVisible.push({ visible: false })
      this.rewardVisibleVisible.push({ visible: false })
      this.userVisibleVisible.push({ visible: false })
    },
    del(index) {
      // delete this.formData[index]
      // console.log(this.formData)
      this.$delete(this.formData, index)
      // this.formData = this.formData.filter((res, key) => {
      //   return index !== key
      // })
    },
    handleTitleClose(done, index) {
      this.titleDialogVisible[index].visible = false
    },
    handleContentClose(done, index) {
      this.ContentDialogVisible[index].visible = false
    },
    handleRewardClose(done, index) {
      this.rewardVisibleVisible[index].visible = false
    },
    handleUserClose(done, index) {
      this.userVisibleVisible[index].visible = false
    },
    selectChange(val, index) {
      for (const i in val) {
        const l = val[i]
        this.formData[index].langs[l] = ''
      }
      console.log(this.formData[index].langs)
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(index) {
      this.formData[index].rewards.push({
        propsId: 0,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    removeReward(index, i) {
      this.formData[index].rewards = this.formData[index].rewards.filter((item, key) => {
        return i !== key
      })
    }
  }
}
</script>

<style scoped>
</style>
